import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';

import TroyLogo from '../../common/Logo/Logo.troy';
import troy from '../../../assets/img/logos/troy/troy_login.png';

import LoginForm from '.';

const LogoComponent = () => (
  <TroyLogo src={troy} className={styles['login-form__form-logo']} />
);

const TroyLoginForm = ({ onSubmit }) => (
  <LoginForm {...{ styles, onSubmit, LogoComponent }} />
);

TroyLoginForm.propTypes = {
  onSubmit: PropTypes.func
};

export default TroyLoginForm;
